module.exports = __webpack_public_path__ + "static/media/IneSports.0b4a6a75.svg";